import React, { Component } from 'react';
import TouchButton from '../TouchButton';

const ExerciseHint = React.createClass({

    getInitialState: function() {
        return {
            showHint: false,
            albertBig: true
        };
    },

    clickHandler: function() {
        this.setState({showHint: !this.state.showHint});
    },

    resizeAlbert: function() {
        this.setState({
            albertBig: !this.state.albertBig
        });
    },

    render: function () {

        let showHint = null,
            albertSize = 'big';
        const hint = 'Fortsätt nu med att addera ihop nästa värdetal med varandra  [5 i 452, och 9 i 295]. En sak måste jag dock lära dig! Om summan av de talen du adderar i varje steg är 10 eller större, så adderas en värdesiffra till nästa steg. I det här fallet blir [5]+[9]=[14], så summan av additionen i det här steget blir [4], med en rest om [1] som läggs till nästa värdesiffra.';

        if(this.state.showHint) {
            showHint = (
                <div className="exercise-hint-content-wrap">
                    <div className="exercise-hint-content">
                        {hint}
                    </div>
                    <TouchButton onClick={this.clickHandler} className="btn btn-link hint-btn">Göm ledtråd</TouchButton>
                </div>
            );
        } else {
            showHint = (
                <TouchButton onClick={this.clickHandler} className="btn btn-link hint-btn">Visa ledtråd</TouchButton>
            );
        }

        const tooltip = (
            <div className="exercise-hint">
                {showHint}
            </div>
        );

        if(this.state.albertBig) {
            albertSize = 'big';
        } else {
            albertSize = 'small';
        }

        return (
            <div className="exercise-hint-container-wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-6 col-xs-push-6">
                            <div onClick={this.resizeAlbert} className={'albert ' + 'albert--'+albertSize}></div>
                            <div className="exercise-hint-wrap">{tooltip}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

});


export default ExerciseHint;


/** WEBPACK FOOTER **
 ** ./src/components/ExerciseHint/ExerciseHint.js
 **/